<template>
  <div class="wrapper">
    <Menu></Menu>
    <div class="main-panel">
      <!-- Navbar -->
      <Head></Head>
      <!-- End Navbar -->
      <div class="content py-0">
        <slot name="body"></slot>
      </div>
      
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Head from "./Head.vue";
export default {
  components: {
    Menu,
    Head,
  },
  created() {},
};
</script>